<template>
  <!-- e代驾的 计价规则 -->
  <div class="container">
    <div class="main">
      <h5>{{info.payFee}}<span>元</span></h5>
      <div class="table">
        <div class="item" v-for="(item,index) in info.feeDetail" :key="index">
          <span>{{item.key}}</span>
          <span>{{item.value}}</span>
        </div>
        <!-- <div class="item">
          <span>计时费 <i>（共0公里）</i></span>
          <span>1.5元</span>
        </div> -->
      </div>
      <p>*车费计算四舍五入取小数点后两位</p>
      <div class="tip">
        <span
          >若您对车费有疑问，可以点击按钮联系客服，我们会在24小时内与您联系</span
        >
      </div>
    </div>
    <p class="rule" @click="goRulse">
      计费规则 <img src="../../assets/img/rightIcon.png" class="rightIcon" />
    </p>
    <div class="bottom">
      <p @click="callTel2"><img src="../../assets/img/icon-tel.png" class="phone" /> 联系客服</p>
    </div>
  </div>
</template>

<script>
import { getWaitPayInfo, e_prive_url } from "@/apis/order/order";
import mobileType from "../../utils/mobileType";
export default {
  data() {
    return {
      data: {},
      params: {},
      orderId: null,
      userId: null,
      driverId: null,
      bookingId: null,
      // orderId: 101050050110101126,
      // userId: "10110007131",
      // driverId: "BJ0019",
      // bookingId: "5da1f1afc0194a1fd3ad454e8c44d689",
      info:{},
      servicePhone:null
    };
  },
  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0,
    });
    //Vue的方法给原生调用，则需要把方法挂在Window下面
    window.getDataFromNative = this.getDataFromNative;
  },
  mounted() {
    let data = decodeURIComponent(this.$route.query.data);
    this.data = JSON.parse(data);

    if (this.data.platform && this.data.platform == 3) {
      this.params = Object.assign({}, this.params, this.data);
      let areaCode = this.params.areaCode;
      let cityCode = +(areaCode.slice(0, 4) + "00");
      this.params.cityCode = cityCode;
      this.orderId = this.params.orderId;
      this.userId = this.params.userId;
      this.driverId = this.params.driverId;
      this.bookingId = this.params.bookingId;

      console.log(this.params);
      this.getInfo();
    } else {
      this.idSelected = this.data.couponId;
      this.orderId = this.data.orderId;
      this.getUserInfoFromApp();
    }
  },

  methods: {
    getUserInfoFromApp() {
      let params = {
        methodName: "getDataFromNative", //定义与原生的方法名(固定)
        type: 1, //业务类型(固定)
      };
      if (mobileType.isIOS()) {
        //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
        window.webkit.messageHandlers.getDataFromVue.postMessage(params);
      } else if (mobileType.isAndroid()) {
        //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
        window.Android.getDataFromVue(JSON.stringify(params));
      } else {
      }
    },
    getDataFromNative(params) {
      if (mobileType.isIOS()) {
        this.params = params;
      } else if (mobileType.isAndroid()) {
        this.params = JSON.parse(params);
      }
      this.getInfo();
    },

    // 获取数据
    async getInfo() {
      let params = {
        ...this.params,
        data: {
          orderId: this.orderId,
          userId: this.userId,
          driverId: this.driverId,
          bookingId: this.bookingId,
        },
      };

      params.data = JSON.stringify(params.data);
      // let params = {"channel":"10600003","deviceId":"82b61777-aeaa-4bb3-b9bc-3ad1c4ca18b9","platform":"3","softVersion":"8.0.5","sysVersion":"iOS 10.0.1","token":"MTAxMTAwMDcxMzE6MTAwOjIwMjAwNTIwMTUyNjA0OTIx","data":"{\"userId\":10110007131,\"orderId\":\"101050050110101126\",\"driverId\":\"BJ0019\",\"bookingId\":\"5da1f1afc0194a1fd3ad454e8c44d689\"}"}
      try {
        const data = await getWaitPayInfo(params);
        if (data.code == 1 && data.data) {
          this.$toast.clear();
          this.info = JSON.parse(data.data);
          this.servicePhone = this.info.servicePhone
        }
      } catch (error) {}
    },
    callTel2(){
      window.location.href = 'tel://'+this.servicePhone;
    },
    goRulse(){
      let url = "https://" + e_prive_url + "/app/price.html?city=" + this.info.startCity;
      window.location.href = url
    }
  },
};
</script>
<style scoped lang="less">
.container {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #f4f5f6;
  padding: 12px 0;
  .main {
    width: 254px;
    padding: 16px 48px 0;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 8px;
    h5 {
      font-size: 24px;
      color: #333;
      line-height: 33px;

      margin: 16px auto 20px;
      span {
        font-size: 15px;
      }
    }
    .table {
      font-size: 15px;
      .item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 30px;
      }
      i {
        font-style: normal;
        font-size: 12px;
        color: #999999;
      }
    }
    p {
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 17px;
      padding: 20px 0;
      border-bottom: 1px solid #ececec;
    }
    .tip {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      padding: 20px 0;
    }
  }
  .rule {
    font-size: 12px;
    padding: 24px 0;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    img {
      vertical-align: middle;
      margin: 0 5px;
      width: 5px;
      height: 5px;
    }
  }
  .bottom {
    position: absolute;
    bottom: 20px;
    font-size: 12px;
    text-align: center;
    left: 0;
    width: 100%;
    padding: 24px 0;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    img {
      vertical-align: middle;
      margin: 0 5px;
      width: 14px;
      height: 14px;
    }
  }
}
</style>

